import { render, staticRenderFns } from "./perfil-sociodemografico-editar.vue?vue&type=template&id=9cc55660&scoped=true&"
import script from "./perfil-sociodemografico-editar.vue?vue&type=script&lang=js&"
export * from "./perfil-sociodemografico-editar.vue?vue&type=script&lang=js&"
import style0 from "./perfil-sociodemografico-editar.vue?vue&type=style&index=0&id=9cc55660&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9cc55660",
  null
  
)

export default component.exports